<template>
  <a-modal
    :visible="true"
    :title="titleDashboard"
    width="900px"
    centered
    :mask-closable="false"
    :body-style="bodyStyle"
    :keyboard="false"
    @cancel="handleCloseModal"
  >
    <section v-if="hasData" class="container__dashboard">
      <div>
        <div class="groups">
          <div>
            <p class="groups--text">Grupos</p>
          </div>
          <div>
            <p class="groups--phone">Cantidad de teléfonos</p>
          </div>
        </div>
        <div v-for="(item, index) in labels" :key="index">
          <div
            class="container__info"
            @mouseenter="handleHover(index)"
            @mouseleave="handleHover(index)"
          >
            <div class="list__info">
              <div class="square" :style="{ background: colors[index] }"></div>
              <span>{{ item }}</span>
            </div>
            <div class="numberPhone">
              <span>{{ series[index] }}</span>
            </div>
          </div>
          <div class="separator"></div>
        </div>
        <div class="container__total">
          <div class="list__info--total">
            <span>Total</span>
          </div>
          <div class="numberPhone">
            <span>{{ total }}</span>
          </div>
        </div>
      </div>
      <div class="dashboard">
        <div id="chart" />
      </div>
    </section>
    <section v-else class="container__no-data">
      <span>Aquí puedes visualizar un resumen de avances de la campaña</span>
    </section>
    <template v-slot:footer>
      <a-button @click="handleCloseModal" class="close-modal-campaign">Cerrar</a-button>

      <a-tooltip :title="isGlobalDownloading ? 'Tiene una descarga pendiente' : null">
        <a-button
          key="submit"
          type="primary"
          :disabled="!hasData || isGlobalDownloading"
          :loading="isLoading"
          @click="handleDownload"
        >
          Descargar datos de la campaña
        </a-button>
      </a-tooltip>
    </template>
  </a-modal>
</template>

<script>
import { defineComponent, ref } from "vue";
import ApexCharts from "apexcharts";

import { fetchDownloadPortfolio } from "@/app/entities/services/";
import { colors } from "@/app/entities/utils/colorsDashboard";
import { useGlobalDownloadState } from "@/app/shared/composables/useGlobalDownloadState";
import { downloadFile } from "@/app/shared/utils/file";

export default defineComponent({
  props: {
    record: {
      required: true,
      type: Object,
    },
    name: {
      required: true,
      type: String,
      default: "",
    },
    idPortfolio: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const { isGlobalDownloading } = useGlobalDownloadState();

    const series = ref(Object.values(props.record));
    const labels = ref(Object.keys(props.record));
    const isLoading = ref(false);
    const total = series.value.reduce(function (valorAnterior, valorActual) {
      return valorAnterior + valorActual;
    }, 0);
    const options = ref({
      chart: {
        id: "chart",
        width: "400px",
        type: "donut",
      },
      // COLOR DE LAS SERIES
      colors: colors,
      // COLOR DEL GRAFICO
      fill: {
        opacity: 1,
        colors: colors,
      },
      labels: labels.value,
      series: series.value,
      //EL LABEL QUE SE SOBREPONE EN EL GRAFICO
      dataLabels: {
        enabled: true,
        style: {
          fontSize: "12px",
          fontWeight: "400",
          colors: ["#595959"],
        },
        dropShadow: {
          enabled: false,
        },
        formatter: (val) => `${val.toFixed(3)}%`,
      },
      tooltip: {
        enabled: true,
        style: {
          fontSize: "14px",
        },
        y: {
          formatter: function (val) {
            return ((parseInt(val) / total) * 100).toFixed(3) + `% (${val})`;
          },
        },
      },
      // ES LA TABLA QUE SE MUESTRA CON LAS SERIES
      legend: {
        show: false,
        position: "right",
        fontSize: "12px",
        itemMargin: {
          horizontal: 5,
          vertical: 10,
        },
        markers: {
          width: 12,
          height: 12,
          strokeWidth: 0,
          radius: 1,
          offsetX: -5,
        },
      },
    });

    return {
      options,
      series,
      labels,
      total,
      colors,
      isLoading,
      isGlobalDownloading,
    };
  },
  data() {
    return {
      bodyStyle: {
        padding: "20px 30px",
        height: "478px",
      },
      chart: undefined,
    };
  },
  mounted() {
    if (this.hasData) {
      setTimeout(() => {
        if (this.chart) this.chart.destroy();
        this.chart = new ApexCharts(document.querySelector("#chart"), this.options);
        this.chart.render();
      }, 100);
    }
  },
  computed: {
    hasData() {
      return Object.keys(this.record).length > 1;
    },
    titleDashboard() {
      return `Dashboard de "${this.name}"`;
    },
  },
  methods: {
    handleCloseModal() {
      if (this.chart) this.chart.destroy();
      this.$emit("onCloseModal");
    },
    handleHover(index) {
      this.chart.toggleDataPointSelection(index);
    },
    async handleDownload() {
      this.isLoading = true;
      const response = await fetchDownloadPortfolio(this.idPortfolio);
      downloadFile(response, `${this.name}.xlsx`, { useResponseFileName: true });
      this.isLoading = false;
    },
  },
});
</script>

<style lang="sass" scoped>
:deep(.ant-modal-body)
  margin: 0 24px

.scrollbar
  width: 350px

.dasboard
  margin-top: -60px

.container__dashboard
  display: flex
  justify-content: space-around

.groups
  display: flex
  margin-top: 30px
  border-bottom: 1px solid  $gray-6
  &--text
    margin-right: 190px
    font-weight: 600
    margin-bottom: 5px
  &--phone
    font-weight: 600
    margin-bottom: 5px

.container__info
  display: flex
  padding: 8px 10px
  justify-content: space-between
  background: $geekblue-1
  border-radius: 10px
  margin-top: 10px
  cursor: pointer

.container__total
  background: $geekblue-4
  display: flex
  padding: 8px 10px
  justify-content: space-between
  border-radius: 10px
  margin-top: 10px

.container__no-data
  height: 100%
  display: flex
  align-items: center
  justify-content: center

  & > span
    line-height: 90px
    font-weight: 600
    font-size: 16px
    color: $gray-6


.list__info
  display: flex
  align-items: center
  &--total
    font-weight: 600
    font-size: 16px


.square
  width: 12px
  height: 12px
  margin-right: 5px

.numberPhone
  color: $blue-6

.separator
  margin-bottom: 10px

.close-modal-campaign
  margin-right: 8px
</style>
